import { css } from '@compiled/react';
import React from 'react';

import Image from '@atlaskit/image';

import PremiumPopupHeaderImageDark from './assets/premiumPopupHeader-Dark.svg';
import PremiumPopupHeaderImageLight from './assets/premiumPopupHeader-Light.svg';
import StandardPopupHeaderImageLight from './assets/standardPopupHeader-Light.svg';
import StandardPopupHeaderImageDark from './assets/standardPopupHeader-Dark.svg';

const imageStyles = css({
	width: '100%',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
	height: '100% !important',
	borderRadius: '16px 16px 0 0',
	objectPosition: 'right',
});

const imageStylesPremium = css({
	transform: 'scale(1.25)',
});

const imageStylesStandard = css({
	objectFit: 'contain',
});

export function StandardImage() {
	return (
		<Image
			src={StandardPopupHeaderImageLight}
			srcDark={StandardPopupHeaderImageDark}
			css={[imageStyles, imageStylesStandard]}
		/>
	);
}
export function PremiumImage() {
	return (
		<Image
			src={PremiumPopupHeaderImageLight}
			srcDark={PremiumPopupHeaderImageDark}
			css={[imageStyles, imageStylesPremium]}
		/>
	);
}
